module.exports = __webpack_public_path__ + "static/media/f5-icon-jx.f3d35493.png";